import i18n from "./i18n";

const customPrimeVueConfig = {
    startsWith: 'Starts with',
    contains: 'Contains',
    notContains: 'Not contains',
    endsWith: 'Ends with',
    equals: 'Equals',
    notEquals: 'Not equals',
    noFilter: 'No Filter',
    lt: 'Less than',
    lte: 'Less than or equal to',
    gt: 'Greater than',
    gte: 'Greater than or equal to',
    dateIs: 'Date is',
    dateIsNot: 'Date is not',
    dateBefore: 'Date is before',
    dateAfter: 'Date is after',
    clear: 'Clear',
    apply: 'Apply',
    matchAll: 'Match All',
    matchAny: 'Match Any',
    addRule: 'Add Rule',
    removeRule: 'Remove Rule',
    accept: i18n.global.t('lib_yes'),
    reject: i18n.global.t('lib_no'),
    choose: 'Choose',
    upload: 'Upload',
    cancel: 'Cancel',
    dayNames: [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday',
    ],
    dayNamesShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    dayNamesMin: [
         i18n.global.t('lib_day_short_sunday'),       
        i18n.global.t('lib_day_short_monday'),
        i18n.global.t('lib_day_short_tuesday'),
        i18n.global.t('lib_day_short_wednesday'),
        i18n.global.t('lib_day_short_thursday'),
        i18n.global.t('lib_day_short_friday'),
        i18n.global.t('lib_day_short_saturday')
    ],
    monthNames: [
        i18n.global.t('lib_month_january'),
        i18n.global.t('lib_month_february'),
        i18n.global.t('lib_month_march'),
        i18n.global.t('lib_month_april'),
        i18n.global.t('lib_month_may'),
        i18n.global.t('lib_month_june'),
        i18n.global.t('lib_month_july'),
        i18n.global.t('lib_month_august'),
        i18n.global.t('lib_month_september'),
        i18n.global.t('lib_month_october'),
        i18n.global.t('lib_month_november'),
        i18n.global.t('lib_month_december'),
    ],
    monthNamesShort: [
        i18n.global.t('lib_month_january_short'),
        i18n.global.t('lib_month_february_short'),
        i18n.global.t('lib_month_march_short'),
        i18n.global.t('lib_month_april_short'),
        i18n.global.t('lib_month_may_short'),
        i18n.global.t('lib_month_june_short'),
        i18n.global.t('lib_month_july_short'),
        i18n.global.t('lib_month_august_short'),
        i18n.global.t('lib_month_september_short'),
        i18n.global.t('lib_month_october_short'),
        i18n.global.t('lib_month_november_short'),
        i18n.global.t('lib_month_december_short'),
    ],
    today: 'Today',
    weekHeader: 'Wk',
    firstDayOfWeek: 1,
    dateFormat: 'dd/mm/yy',
    weak: 'Weak',
    medium: 'Medium',
    strong: 'Strong',
    passwordPrompt: 'Enter a password',
    emptyFilterMessage: 'No results found',
    emptyMessage: 'No available options',
};

export default customPrimeVueConfig;
